import ReactDOM from 'react-dom/client';
import { ConvexReactClient } from 'convex/react';
import {
  ConvexBetterAuthProvider,
  type AuthClient,
} from '@convex-dev/better-auth/react';
import { AuthProvider } from './contexts/AuthContext';
import { authClient } from './lib/auth-client';
import App from './App';
import './styles/index.css';

const convexUrl = import.meta.env.VITE_CONVEX_URL;
if (!convexUrl) {
  throw new Error('VITE_CONVEX_URL is required.');
}

const convex = new ConvexReactClient(convexUrl);
// The provider's published type only models its Convex plugin, while this
// client also includes Better Auth's username plugin. Both plugins are present
// at runtime, so keep the workaround local to the provider boundary.
const providerAuthClient = authClient as unknown as AuthClient;

ReactDOM.createRoot(document.getElementById('root')!).render(
  <ConvexBetterAuthProvider
    client={convex}
    authClient={providerAuthClient}
  >
    <AuthProvider>
      <App />
    </AuthProvider>
  </ConvexBetterAuthProvider>
);
